import { Paper, IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, FormControl, TextField, Autocomplete, createFilterOptions, Box, Chip, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import LoadingSimpleBackdrop from '../../tools/LoadingSimpleBackdrop';
import Message from '../../tools/Message';
import Title from '../../../components/Title';
import {makeStyles } from '@material-ui/core';
import TimeSheetMissionService from '../../../services/TimeSheetMissionService';
import HistoryIcon from '@mui/icons-material/History';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DownloadTwoToneIcon from '@mui/icons-material/DownloadTwoTone';
import { headerData } from '../../../data/modules/my-validations-header';
import { useNavigate } from 'react-router';
import { DataGrid } from '@mui/x-data-grid';
import DoneIcon from '@mui/icons-material/Done';
import MainContainer from '../../../components/MainContainer';
import SearchIcon from '@mui/icons-material/Search';
import Spacer from '../../../components/Spacer';
import ProvisionalFuelMissionService from '../../../services/ProvisionalFuelMissionService';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "10px!important",
    marginTop: "1%",
    height: "60%",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  },
  btn: {
    margin: "1% 0.25% 1% 0.25%",
    fontWeight: 600,
    boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"
  },
}));

const formatFilterDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const createDefaultFuelMissionFilter = () => {
  const now = new Date();
  const firstDayCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDayThirdMonth = new Date(now.getFullYear(), now.getMonth() + 4, 0);

  return {
    title: '',
    state: '',
    indemnityState: '',
    reference: '',
    destination: '',
    debut: formatFilterDate(firstDayCurrentMonth),
    fin: formatFilterDate(lastDayThirdMonth)
  };
};

const FuelMissionTable = () => {
    const navigate = useNavigate();
    const classes = useStyles();
    const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
    const [rows, setRows] = useState([]);
    const [reference, setReference] = useState([]);
    const [filter, setFilter] = useState(createDefaultFuelMissionFilter);
    const [appliedFilter, setAppliedFilter] = useState(createDefaultFuelMissionFilter);
    const [message, setMessage] = useState({
         open: false,
         color: 'green',
         messageInfo: '',
    });
    const [confirmDialog, setConfirmDialog] = useState({
      open: false,
      mission_planning_id: null,
      agenda_id: null,
      timesheet_id: null,
    });
    const [, setOpenShareDialog] = useState({open: false, mission_timesheet_id: null, mission_planning_agenda_id: null, mission_planning_id: null});
    const [openActivateDialog, setOpenActivateDialog] = useState({open: false, mission_timesheet_id: null});
    const { open, color, messageInfo } = message;
    const STATE_FUEL = [
    { label: 'Nouveau', value: "NEW", color: '#33ccff' },
    { label: 'En attente de confirmation', value: 'PENDING', color: 'purple' },
    { label: 'Confirmé', value: 'CONFIRMED', color: 'green' },
    { label: 'Refusé', value: 'REFUSED', color: 'red' },
    { label: 'Tous', value: '', color: '#33ccff' }
  ];
    
    const referenceFilterOptions = createFilterOptions({
      matchFrom: 'any',
      stringify: (option) => option ?? ''
    });

    const buildFuelMissionRowId = (item = {}) => [
      item.mission_planning_id || 0,
      item.mission_planning_agenda_id || 0,
      item.mission_timesheet_id || 0,
      item.provisional_fuel_id || 0,
      item.indemnity_validation_id || 0
    ].join('-');

    const getEarlierDate = (currentValue, nextValue) => {
      if (!currentValue) {
        return nextValue || '';
      }
      if (!nextValue) {
        return currentValue;
      }
      return new Date(nextValue) < new Date(currentValue) ? nextValue : currentValue;
    };

    const getLaterDate = (currentValue, nextValue) => {
      if (!currentValue) {
        return nextValue || '';
      }
      if (!nextValue) {
        return currentValue;
      }
      return new Date(nextValue) > new Date(currentValue) ? nextValue : currentValue;
    };

    const aggregateFuelMissionRows = (items = []) => {
      const groupedRows = new Map();

      (items || []).forEach((item) => {
        const rowId = buildFuelMissionRowId(item);
        const rowDestination = item?.lieu || item?.lieu_destination || '';

        if (!groupedRows.has(rowId)) {
          groupedRows.set(rowId, {
            id: rowId,
            ...item,
            lieu: rowDestination,
            _destinations: new Set(rowDestination ? [rowDestination] : [])
          });
          return;
        }

        const currentRow = groupedRows.get(rowId);
        if (rowDestination) {
          currentRow._destinations.add(rowDestination);
        }

        currentRow.date_begin = getEarlierDate(currentRow.date_begin, item?.date_begin || item?.date_debut);
        currentRow.date_end = getLaterDate(currentRow.date_end, item?.date_end || item?.date_fin);
      });

      return Array.from(groupedRows.values()).map((item) => {
        const { _destinations, ...row } = item;
        return {
          ...row,
          lieu: Array.from(_destinations || []).join(', ')
        };
      });
    };

    const filterRowsByIndemnityState = (items = [], indemnityState = '') => {
      if (!indemnityState) {
        return items;
      }
      return items.filter(
        (item) => (item?.indemnity_validation_state || 'NEW') === indemnityState
      );
    };
    
     function handleCloseMessage() {
      setMessage({ ...message, open: false });
    }

    const handleChangeFilter = (e) => {
      const { name, value } = e.target;
      setFilter(prev => ({ ...prev, [name]: value }));
    };

    const handleFilter = () => {
      setAppliedFilter({ ...filter });
    };

    const handleResetFilter = () => {
      const defaultFilter = createDefaultFuelMissionFilter();
      setFilter({ ...defaultFilter });
      setAppliedFilter({ ...defaultFilter });
    };

    const fetchData = async (currentFilter = appliedFilter) => {
      setOpenLoadingSimpleBackdrop(true);
      try{
        const response = await ProvisionalFuelMissionService.getFuelMissions(currentFilter);
        if(response && response.status){
          const aggregatedRows = aggregateFuelMissionRows(response.data || []);
          const filteredRows = filterRowsByIndemnityState(
            aggregatedRows,
            currentFilter.indemnityState
          );
          setRows(filteredRows);
          const references = [...new Set(filteredRows.map(item => item.reference).filter(Boolean))];
          setReference(references);
        }
        setMessage({ open: true, color: 'green', messageInfo: 'Données chargées avec succès.' });
      }catch(err){
        setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors du chargement des données.' });
      }finally{
        setOpenLoadingSimpleBackdrop(false);
      }

    };

    useEffect(() => {
      fetchData(appliedFilter);
    }, [appliedFilter]);

    useEffect(() => {
      if(confirmDialog.open === false && (confirmDialog.timesheet_id || confirmDialog.agenda_id || confirmDialog.mission_planning_id)){
        fetchData(appliedFilter);
      }
    }, [confirmDialog.open, appliedFilter]);

    
    const handleShowActivateDialog = (mission_timesheet_id) => {
      setOpenActivateDialog({ open: true, mission_timesheet_id });
    };

    const handleActivateTimesheet = async (mission_timesheet_id) => {
      setOpenActivateDialog({ open: false, mission_timesheet_id: null });
      setOpenLoadingSimpleBackdrop(true);
      try{
        const response = await TimeSheetMissionService.activateTimesheet(mission_timesheet_id);
        if(response && response.status){
          setMessage({ open: true, color: 'green', messageInfo: 'Le timesheet a été réactivé avec succès.' });
          fetchData();
        }
      }catch(err){
        setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la réactivation du timesheet.' });
      }
      setOpenLoadingSimpleBackdrop(false);
    };

  const getFuelState = (state) => (
    STATE_FUEL.find((option) => option.value === state) || STATE_FUEL[0]
  );

  const formatDate = (value) => {
    if (!value) {
      return '-';
    }

    const [datePart] = `${value}`.split(' ');
    const [year, month, day] = datePart.split('-');
    return year && month && day ? `${day}/${month}/${year}` : value;
  };

  const renderWrappedCell = (value) => (
    <Tooltip title={value || ''} placement="top-start" arrow>
      <Typography
        variant="body2"
        sx={{
          width: '100%',
          fontSize: '0.78rem',
          lineHeight: 1.45,
          whiteSpace: 'normal',
          overflowWrap: 'anywhere',
        }}
      >
        {value || '-'}
      </Typography>
    </Tooltip>
  );

  const columns = [
   {
    field: 'action',
    headerName: 'Actions',
    width: 205,
    sortable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, width: '100%' }}>
        {
           (params.row.provisional_fuel_state !== 'CONFIRMED' && params.row.provisional_fuel_state !== "PENDING") || (params.row.indemnity_validation_state !== "PENDING" &&  params.row.indemnity_validation_state !== 'CONFIRMED') ?
          <Button
            color="info"
            aria-label="edit"
            variant='contained'
            label="Confirmer "
            component="span"
            size='small'
            onClick={() => navigate(`/mission/fuel/confirm/${params.row.mission_planning_id}/${params.row.mission_planning_agenda_id}/${params.row.mission_timesheet_id}/${params.row.provisional_fuel_id}`)}
            startIcon={<DoneIcon />}
            sx={{
              textTransform: 'none',
              // fontWeight: 700,
              borderRadius: '8px',
              px: 1.5,
              minWidth: 120,
              marginRight: 1,
              // background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)',
              boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              transition: 'all 0.2s ease',
              '&:hover': {
                // background: 'linear-gradient(135deg, #15803d 0%, #16a34a 100%)',
                boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
                transform: 'translateY(-1px)',
              },
              '&:active': {
                transform: 'translateY(0)',
              },
            }}
          >
          Confirmer
          </Button>
        : 
          <IconButton  aria-label="confirmed" label="Carburant, indemnité confirmée"
            onClick={() => navigate(`/mission/fuel/confirm/${params.row.mission_planning_id}/${params.row.mission_planning_agenda_id}/${params.row.mission_timesheet_id}/${params.row.provisional_fuel_id}`)}
           component="span" variant="outlined" size='small'>
            <RemoveRedEyeIcon />
          </IconButton>
        }
        {
            // params.row.mission_timesheet_state !== null &&
           <IconButton 
                title="Historique des modifications"  
                size="small" 
                variant="outlined"                
                color="info" 
                onClick={() => navigate(`/mission/fuel/history/${params.row.mission_planning_agenda_id}/0`)}
              >
                <HistoryIcon /> 
              </IconButton>
        }
      </Box>
    )
  },
  {
    field: 'reference',
    headerName: 'Référence',
    minWidth: 125,
    flex: 0.7,
    renderCell: (params) => renderWrappedCell(params.value)
  },
  {
    field: 'mission_title',
    headerName: 'Objet de la mission',
    minWidth: 220,
    flex: 1.5,
    renderCell: (params) => renderWrappedCell(params.value)
  },
  {
    field: 'lieu',
    headerName: 'Destination',
    minWidth: 170,
    flex: 1,
    renderCell: (params) => renderWrappedCell(params.value)
  },
  {
    field: 'date_begin',
    headerName: 'Date début',
    width: 115,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => formatDate(params.value),
  },
  {
    field: 'date_end',
    headerName: 'Date fin',
    width: 115,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => formatDate(params.value),
  },
  {
    field: 'provisional_fuel_state',
    headerName: 'Statut Carburant',
    width: 155,
    align: 'center',
    headerAlign: 'center',
    renderHeader: () => (
      <strong>
        Statut{"\n"}Carburant
      </strong>
    ),
    renderCell: (params) => {
      const state = getFuelState(params.value);
      return (
        <Chip
          label={state.label}
          size="small"
          sx={{
            maxWidth: '100%',
            color: state.color,
            bgcolor: `${state.color}14`,
            border: `1px solid ${state.color}45`,
            fontWeight: 700,
            fontSize: '0.7rem',
            '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
          }}
        />
      );
    }
  },
  {
    field: 'indemnity_validation_state',
    headerName: 'Statut Indemnité',
    width: 155,
    align: 'center',
    headerAlign: 'center',
    renderHeader: () => (
      <strong>
        Statut{"\n"}Indemnité
      </strong>
    ),
    renderCell: (params) => {
      const state = getFuelState(params.value);
      return (
        <Chip
          label={state.label}
          size="small"
          sx={{
            maxWidth: '100%',
            color: state.color,
            bgcolor: `${state.color}14`,
            border: `1px solid ${state.color}45`,
            fontWeight: 700,
            fontSize: '0.7rem',
            '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
          }}
        />
      );
    }
  },
  
];

const handleDownloadFile = async (mission_planning_id, mission_planning_agenda_id, mission_timesheet_id) => {
  setOpenLoadingSimpleBackdrop(true);
  try{
    const response = await TimeSheetMissionService.downloadTimesheetFile(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id);
    if(response){
      const fileURL = window.URL.createObjectURL(new Blob([response], { type: 'application/zip' }));
      const fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', `timesheet_${mission_timesheet_id}.zip`);
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
      window.URL.revokeObjectURL(fileURL);
      setMessage({ open: true, color: 'green', messageInfo: 'Le fichier a été téléchargé avec succès.' });
    }
  }catch(err){
    setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors du téléchargement du fichier.' });
  }
  setOpenLoadingSimpleBackdrop(false);
};

return (
      <MainContainer {...headerData}>  
      <Grid container spacing={3} padding={1}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
        <Grid container xs={12} spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                  <label>Objet de la mission :</label>
                  <FormControl fullWidth variant="outlined" size="small">
                  <TextField
                    fullWidth
                    id="title"
                    size="small"
                    variant="outlined"
                    value={filter.title}
                    name="title"
                    onChange={handleChangeFilter}
                  />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <label>Status carburant :</label>
                  <FormControl fullWidth variant="outlined" size="small">
                  <Autocomplete
                    disablePortal
                    id="state"
                    fullWidth
                    options={STATE_FUEL}
                    size="small"
                    variant="outlined"
                    getOptionLabel={(option) => option.label}
                    value={STATE_FUEL.find(option => option.value === filter.state) || { label: 'Tous', value: '' }}
                    onChange={(_, newValue) => {
                      setFilter(prev => ({ ...prev, state: newValue ? newValue.value : '' }));
                    }}
                    renderInput={(params) => <TextField {...params} label="" variant="outlined" size="small"/>}
                  />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <label>Statut indemnité :</label>
                  <FormControl fullWidth variant="outlined" size="small">
                  <Autocomplete
                    disablePortal
                    id="indemnityState"
                    fullWidth
                    options={STATE_FUEL}
                    size="small"
                    variant="outlined"
                    getOptionLabel={(option) => option.label}
                    value={STATE_FUEL.find(option => option.value === filter.indemnityState) || { label: 'Tous', value: '' }}
                    onChange={(_, newValue) => {
                      setFilter(prev => ({ ...prev, indemnityState: newValue ? newValue.value : '' }));
                    }}
                    renderInput={(params) => <TextField {...params} label="" variant="outlined" size="small"/>}
                  />
                  </FormControl>
                </Grid>
                <Grid item container xs={12} sm={6} md={3} spacing={4} justifyContent={"flex-end"} >
                  
                  <Spacer x={1} />
                  <div style={{paddingTop: '50px'}}>
                    <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleResetFilter}
                    className={classes.btn}
                  >
                    Réinitialiser
                  </Button>
                  </div>
                  <Spacer x={1} />
                  <div style={{paddingTop: '50px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFilter}
                    className={classes.btn}
                  >
                    <SearchIcon style={{ marginRight: '8px' }} />
                    Filtrer
                  </Button>
                 
                  </div>
                  <Spacer x={1} />
                </Grid>              
                <Grid item xs={12} sm={6} md={3}>
                    <label>Référence:</label>
                    <FormControl fullWidth variant="outlined" size="small">
                    <Autocomplete
                        id="tags-outlined"
                        freeSolo
                        options={reference}
                        filterOptions={referenceFilterOptions}
                        sx={{
                        '& .MuiInputBase-root': { height: 40 }, 
                        '& .MuiInputBase-input': { padding: '4px 8px' } 
                        }}
                        getOptionLabel={(option) =>
                        `${option ?? ''}`
                        }
                        filterSelectedOptions
                        onChange={(_, newValue) => {
                          setFilter(prev => ({ ...prev, reference: newValue || '' }));
                        }}
                        inputValue={filter.reference}
                        onInputChange={(_, newInputValue) => {
                          setFilter(prev => ({ ...prev, reference: newInputValue || '' }));
                        }}
                        size='small'
                        value={filter.reference}
                        renderInput={(params) => (
                        <TextField {...params} variant="outlined" size="small" />
                        )}
                    />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    Destination :
                    <TextField
                    fullWidth
                    id="destination"
                    size="small"
                    variant="outlined"
                    value={filter.destination}
                    name="destination"
                    onChange={handleChangeFilter}
                    />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        Date début:
                        <TextField
                        fullWidth
                        id="date_debut"
                        size="small"
                        variant="outlined"
                        type="date"
                        value={filter.debut}
                        name="debut"
                        onChange={handleChangeFilter}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        Date fin:
                        <TextField
                        fullWidth
                        id="date_fin"
                        size="small"
                        variant="outlined"
                        type="date"
                        value={filter.fin}
                        name="fin"
                        onChange={handleChangeFilter}
                        />
                    </Grid>
        </Grid>
        <Paper className={classes.paper} variant="outlined">
          <Title>Carburant / indemnité prévisionnel pour les missions</Title>
                <Box sx={{ height: 640, width: '100%', mt: 1 }}>
                        <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowId={(row) => row.id}
                getRowHeight={() => 'auto'}
                getEstimatedRowHeight={() => 72}
                sx={{
                  border: 0,
                  color: '#334155',
                  fontSize: '0.78rem',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f4f7fb',
                    borderBottom: '1px solid #dce6f3',
                    color: '#29476f',
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 700,
                    whiteSpace: 'normal',
                    lineHeight: 1.2,
                    textAlign: 'center',
                  },
                  '& .MuiDataGrid-row': {
                    minHeight: '62px !important',
                  },
                  '& .MuiDataGrid-row:nth-of-type(even)': {
                    backgroundColor: '#fbfdff',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: '#f1f7fd',
                  },
                  '& .MuiDataGrid-cell': {
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '62px !important',
                    py: 1,
                    whiteSpace: 'normal',
                    lineHeight: 1.45,
                    borderColor: '#edf1f7',
                    overflow: 'visible',
                  },
                  '& .MuiDataGrid-cellContent': {
                    width: '100%',
                    whiteSpace: 'normal',
                    lineHeight: 1.45,
                    overflowWrap: 'anywhere',
                  },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: '1px solid #dce6f3',
                    backgroundColor: '#fafcff',
                  },
                }}
            />
            </Box>
            </Paper>
            <Dialog open={openActivateDialog.open} onClose={() => setOpenActivateDialog({ open: false, mission_timesheet_id: null })}>
              <DialogTitle id="form-dialog-title" style={{ color: "white" }}>Réactiver le timesheet</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Êtes-vous sûr de vouloir réactiver le timesheet pour modification ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenActivateDialog({ open: false, mission_timesheet_id: null })} color="info" variant='outlined'>
                  Annuler
                </Button>
                <Button onClick={() => handleActivateTimesheet(openActivateDialog.mission_timesheet_id)} color="info" variant='contained'>
                  Réactiver
                </Button>
              </DialogActions>
            </Dialog>
      </Grid>
      </MainContainer>
);
};
export default FuelMissionTable;
